import { render, staticRenderFns } from "./Grouped.vue?vue&type=template&id=83a47210"
import script from "./Grouped.vue?vue&type=script&lang=js"
export * from "./Grouped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports